import * as React from 'react'
import { FormattedMessage } from 'react-intl'
import AvailabilityLegends from '@components/AvailabilityLegends'
import { Header } from './style'

interface Props {
  title?: React.ReactNode
}

const CustomHeader = ({ title }: Props) => (
  <Header>
    {title ? title : <FormattedMessage id="Availability" />}
    <AvailabilityLegends />
  </Header>
)

export default CustomHeader
